module.exports = __webpack_public_path__ + "static/media/faccia_07.1a068541.png";